import styled from "styled-components";
import { pagePadding } from "_/style/layout";

export const Wrapper = styled.div`
  ${pagePadding}
`;

export const SubHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 1.5rem;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
